import { requireAnySystemPermission, requireOrgPermission } from '../../../../../../../../backend/features/permissions/shared';
export function resolveStatusValues(userState, orgId, orgStatusMap, currentStatus) {
    const canManageMembership = requireOrgPermission(userState, orgId, 'manage-members') ||
        (requireAnySystemPermission(userState, 'manage-accounts') &&
            requireAnySystemPermission(userState, 'manage-accounts-organizations'));
    return Object.entries(orgStatusMap)
        .filter(([value]) => {
        if (canManageMembership) {
            return true;
        }
        else if (currentStatus) {
            return value === 'withdrawn' || value === 'pending';
        }
        else {
            return value === 'pending';
        }
    })
        .map(([value, { label }]) => ({ value, label }));
}
